"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsPreviewContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const hooks_1 = require("./hooks");
const products_action_panel_1 = require("./products-action-panel");
const products_list_view_1 = require("./products-list-view");
const products_preview_component_1 = require("./products-preview.component");
const products_preview_styles_1 = require("./products-preview.styles");
const products_preview_utils_1 = require("./products-preview.utils");
const product_details_dialog_component_1 = require("../../product-details-dialog/product-details-dialog.component");
const bulk_edit_product_attributes_dialog_1 = require("../bulk-edit-product-attributes-dialog");
const reclassify_products_dialog_component_1 = require("../reclassify-products-dialog/reclassify-products-dialog.component");
const products_table_1 = require("../../../components/products-table");
const context_1 = require("../../../context");
const hooks_2 = require("../../../hooks");
const products_table_2 = require("../../../store/catalogs/products-table");
const store_1 = require("../../../../store");
const ProductsPreviewContainer = (_a) => {
    var { isListViewMode } = _a, productsActionPanelProps = __rest(_a, ["isListViewMode"]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isNodeReEnriching, isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const searchTerm = (0, products_table_2.useProductsTableSearch)();
    const tableFilter = (0, products_table_2.useProductsTableFilter)();
    const { reviewAttribute } = (0, products_table_2.useProductsTableDynamicColumns)();
    const selectedProductTreeNode = (0, hooks_2.useSelectedTreeNode)();
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    const [isCustomizeViewOpen, setIsCustomizeViewOpen] = (0, react_1.useState)(false);
    const [isBulkEditRefreshing, setIsBulkEditRefreshing] = (0, react_1.useState)(false);
    const { id: selectedStrategyNodeId } = selectedProductTreeNode !== null && selectedProductTreeNode !== void 0 ? selectedProductTreeNode : {};
    const isCurrentNodeReEnriching = (0, react_1.useMemo)(() => isNodeReEnriching(selectedStrategyNodeId), [isNodeReEnriching, selectedStrategyNodeId]);
    const { products, isLoading: areProductsLoading, isPageRowsSyncing, arePageRowsIncomplete, paginationModel, onPaginationModelChange, error, chunkLoadErrorProductCount, canRetryChunkLoad, retryChunkLoad, totalCount, lockedProductsCount, lastVariables, } = (0, hooks_1.useProductList)(isListViewMode);
    const productIds = (0, react_1.useMemo)(() => products.map(({ id }) => id), [products]);
    const validPageIdsSet = (0, react_1.useMemo)(() => new Set(productIds), [productIds]);
    const lockedProductIds = (0, react_1.useMemo)(() => products.filter((p) => p.isLocked).map((p) => p.id), [products]);
    const { productIdForDetailsModal, setProductIdForDetailsModal, productDetailsModalProps, } = (0, products_table_1.useProductDetailsModal)({
        productIds,
    });
    const extractedProductTreeNode = (0, react_1.useMemo)(() => { var _a; return (_a = products.find(({ id }) => id === productIdForDetailsModal)) === null || _a === void 0 ? void 0 : _a.productTreeNodeId; }, [productIdForDetailsModal, products]);
    const selection = (0, ui_components_1.useAdvancedSelection)({
        totalCount,
    });
    const { selectionModel, setSelectionModel, resetSelection, selectItem, deselectItem, selectMultiple, isItemSelected, isAllSelected, selectAllMode, excludedItemsIds, areAllItemsSelected, selectedItemsCount, isAtLeastOneItemSelected, } = selection;
    const sanitizedSetSelectionModel = (0, react_1.useCallback)((modelOrUpdater) => {
        setSelectionModel((prev) => {
            const next = typeof modelOrUpdater === 'function' ? modelOrUpdater(prev) : modelOrUpdater;
            return (0, products_preview_utils_1.sanitizeSelectionModel)(next, prev, validPageIdsSet);
        });
    }, [setSelectionModel, validPageIdsSet]);
    const { handleSelectAll } = (0, ui_components_1.useSelectionWithDisabledRows)(Object.assign(Object.assign({}, selection), { unselectableIds: lockedProductIds }));
    (0, react_1.useEffect)(() => {
        resetSelection();
    }, [resetSelection, selectedStrategyNodeId]);
    (0, react_1.useEffect)(() => {
        if (isCurrentNodeReEnriching) {
            resetSelection();
        }
    }, [resetSelection, isCurrentNodeReEnriching]);
    (0, react_1.useEffect)(() => {
        resetSelection();
    }, [resetSelection, searchTerm, tableFilter, selectedAttributeNode]);
    const handleReclassifyComplete = (0, react_1.useCallback)(() => {
        if (areAllItemsSelected) {
            // clear selected attribute/value when all items were reclassified
            dispatch((0, store_1.enrichAISetSelectedAttributeNode)(null));
        }
        resetSelection();
    }, [areAllItemsSelected, dispatch, resetSelection]);
    const { isBulkEditModalOpen, setBulkEditModalOpen, bulkEditModalProps, } = (0, products_table_1.useBulkEditProductsModal)({
        onBulkEditComplete: resetSelection,
        selectAllMode,
        tableSearch: searchTerm,
        excludedItemsIds: excludedItemsIds,
        tableFilter,
        productTreeNode: selectedProductTreeNode,
        selectedAttributeNode,
        hasLockedProducts: lockedProductsCount > 0,
        reviewAttribute,
    });
    const [contextMenuAttribute, setContextMenuAttribute] = (0, react_1.useState)();
    const handleBulkEdit = () => {
        setContextMenuAttribute(undefined);
        setBulkEditModalOpen(true);
    };
    const handleContextMenuEdit = (0, react_1.useCallback)((attributeName) => {
        setContextMenuAttribute(attributeName);
        setBulkEditModalOpen(true);
    }, [setBulkEditModalOpen]);
    const { isBulkReclassifyModalOpen, setBulkReclassifyModalOpen, onReclassifySingleProduct, bulkReclassifyModalProps, } = (0, products_table_1.useBulkReclassifyProductsModal)({
        onBulkReclassifyComplete: handleReclassifyComplete,
        selectedItemsCount,
        selectAllMode,
        tableSearch: searchTerm,
        excludedItemsIds: excludedItemsIds,
        tableFilter,
        productTreeNode: selectedProductTreeNode,
        selectedAttributeNode,
        hasLockedProducts: lockedProductsCount > 0,
    });
    const handleBulkReclassify = () => {
        setBulkReclassifyModalOpen(true);
    };
    const commonProps = {
        products,
        paginationModel,
        totalCount,
        onPaginationModelChange,
        areProductsLoading: areProductsLoading || isBulkEditRefreshing,
        isPageRowsSyncing,
        arePageRowsIncomplete,
        chunkLoadErrorProductCount,
        canRetryChunkLoad,
        retryChunkLoad,
        productsLoadingError: error,
        lastVariables,
        isCustomizeViewOpen,
        onActiveProductIdChange: setProductIdForDetailsModal,
        onCustomizeViewClose: () => setIsCustomizeViewOpen(false),
    };
    const selectCurrentPage = (0, react_1.useCallback)(() => selectMultiple(productIds), [selectMultiple, productIds]);
    const isCurrentPageSelected = (0, react_1.useMemo)(() => isAllSelected(productIds), [isAllSelected, productIds]);
    return (react_1.default.createElement(products_preview_styles_1.StyledProductPreviewSectionContainer, null, isBulkReclassifyModalOpen && (react_1.default.createElement(reclassify_products_dialog_component_1.ReclassifyProductsDialog, Object.assign({}, bulkReclassifyModalProps))), isBulkEditModalOpen && (react_1.default.createElement(bulk_edit_product_attributes_dialog_1.BulkEditProductAttributesDialog, Object.assign(Object.assign({ selectedTreeNodeId: selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.id }, bulkEditModalProps), { selectedProductsCount: selectedItemsCount, expectedMatchedProductCount: selectAllMode ? selectedItemsCount : undefined, initialAttributeId: contextMenuAttribute !== null && contextMenuAttribute !== void 0 ? contextMenuAttribute : bulkEditModalProps.initialAttributeId, onProductListRefreshStateChange: setIsBulkEditRefreshing }))), react_1.default.createElement(products_action_panel_1.ProductsActionPanel, Object.assign(Object.assign({}, productsActionPanelProps), { showReclassificationButton: true, isListViewMode: isListViewMode, totalCount: totalCount, lockedProductsCount: lockedProductsCount, isAtLeastOneProductSelected: isAtLeastOneItemSelected, onSelectCurrentPage: selectCurrentPage, selectedItemsCount: selectedItemsCount, onReclassify: handleBulkReclassify, onEdit: handleBulkEdit, onSettingsClick: () => setIsCustomizeViewOpen(true), onResetSelectedProducts: resetSelection, isCurrentPageSelected: isCurrentPageSelected, onSelectAllProducts: handleSelectAll, areAllProductsSelected: areAllItemsSelected, productTreeNodeId: selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.id, disableReclassification: isReEnrichmentInProgress })), isListViewMode
        ? (react_1.default.createElement(products_list_view_1.ProductsListView, Object.assign(Object.assign({}, commonProps), { selectionModel: selectionModel, setSelectionModel: sanitizedSetSelectionModel, onContextMenuEdit: handleContextMenuEdit, isAtLeastOneProductSelected: isAtLeastOneItemSelected, selectProduct: selectItem })))
        : (react_1.default.createElement(products_preview_component_1.ProductsPreview, Object.assign(Object.assign({}, commonProps), { activeProductId: productIdForDetailsModal, isItemSelected: isItemSelected, selectItem: selectItem, deselectItem: deselectItem }))), !!productIdForDetailsModal && (react_1.default.createElement(product_details_dialog_component_1.ProductDetailsDialog, Object.assign(Object.assign({}, productDetailsModalProps), { productTreeNodeId: extractedProductTreeNode, onReclassify: () => {
            onReclassifySingleProduct(productIdForDetailsModal);
            setProductIdForDetailsModal(null);
        } })))));
};
exports.ProductsPreviewContainer = ProductsPreviewContainer;
exports.default = exports.ProductsPreviewContainer;
